export const FILTER_TYPES = {
	line: 'lineIds',
	from: 'fromCityIds',
	to: 'toCityIds',
	trip: 'tripNumbers',
	run: 'runNames',
};

export const EMPTY_VALUES = {
	fromCityIds: '',
	toCityIds: '',
	lineIds: '',
	tripNumbers: '',
	runNames: '',
	departureRange: '',
	time: '00:00',
};

export const ALLOWED_DEADHEAD_FILTER_TYPES = ['departureRange', 'fromCityIds', 'toCityIds'];
export const RUN_NAMES_FILTER_KEY = 'runNames';
export const TRIP_NUMBERS_FILTER_KEY = 'tripNumbers';
export const DEPARTURE_RANGE_FILTER_KEY = 'departureRange';
export const TIME_FILTER_KEY = 'time';
export const LOCAL_STORAGE_SOURCE = 'filtersRideList';
